import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const ContextOne = () => {
    return (
        <div className="App">
            <div className="App-body">
                <p>
                    Among the jumbled items, you discover Nina's work memo pad. As you leaf through 
                    the pages filled with her elegant handwriting, you notice that her thoughts often 
                    wandered to the realms of her favorite books. Quotes from Shakespeare are 
                    interspersed among her work notes, reflecting her literary passion and perhaps 
                    providing comfort amid the corporate chaos. These entries, marked by a mix of 
                    anxiety and cryptic yet intentional information, hint at the depth of her intellect 
                    and the stress she faced.
                </p>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='/BoxOne/ContextOneTwo'>Continue</Button>
            </div>
        </div>
    );
  };
  
export default ContextOne;